import { createSlice } from '@reduxjs/toolkit';

export const counterSlice = createSlice({
  initialState: {
    stepIndexesThatStartedTakingQuiz: [],
    stepIndexesWhereQuizWasPassed: [],
  },
  name: 'videoQuizzes',
  reducers: {
    passQuiz: (state, action) => {
      const stepIndex = action.payload;
      if (!state.stepIndexesWhereQuizWasPassed.includes(stepIndex)) {
        state.stepIndexesWhereQuizWasPassed.push(stepIndex);
      }
    },
    takeQuiz: (state, action) => {
      const stepIndex = action.payload;
      if (!state.stepIndexesThatStartedTakingQuiz.includes(stepIndex)) {
        state.stepIndexesThatStartedTakingQuiz.push(stepIndex);
      }
    },
  },
});

export const { takeQuiz, passQuiz} = counterSlice.actions;

export const selectVideoQuizzes = (state) => state.videoQuizzes;

export default counterSlice.reducer;
